import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterPipe } from '../shared/router.pipe';

@NgModule({
  declarations: [
    RouterPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    RouterPipe
  ],
  providers: [
    RouterPipe
  ]
})
export class SharedModule { }
